export interface emailObjType {
    companyName: string,
    companyLogo: string,
    headerAfterName: string,
    description: string,
    installmentOption: number,
    ifFreePeriod: boolean,
    freePeriod: number,
    refLink: string,
    salaryAdvanceService: string,
    paymentService: string,
    internalTransferringService: string,
    shoppingService: string,
    payrollDescription: string,
    serviceFees: number,
    howItWorks1: string,
    howItWorks2: string,
    howItWorks3: string,
    howItWorks4: string,
    videoLink: string,
    questionsContact: string,
    questionsString: string
}

export interface companyInfo {
    name: string,
    companyName: string,
    id: number,
    description: string,
    logoID: string,
    salaryCycleStartDay: string,
    salaryCycleEndDay: string,
    arabicName: string,
    arabicDescription: string,

    maxInstallmentCount: string,
    salaryPreparationDay: string,

    maxAdvancePercentAllowed: number,
    fees: number,
    shoppingBalancePercentage: number,

    createdAt: string,
    staff_id: string,
    maxShoppingInstallmentsCount: number,
    deployed: any,
    companyType: string | null,
    companyIndustry: string | null,
    cashEnabled: number | null,
    requestRequiresActiveUser: number | null,
    staffIDRequired: number | null,
    consentRequired: number | null,
    hrLetterRequired: number | null,
    nationalIDRequired: number | null,
    promissoryNoteRequired: number | null,
    requestRequiredHRApproval: number | null,
    nationalIDRequiredByCompany: number | null,
    staffIDRequiredByCompany: number | null,
    hasDeductionBasedFreePeriods: number | null,
    estimatedNumbersOfUsers: number,
    collectionDayExact: number,
    userFreePaymentCycles: number,
    companyFreeMonths: number,
    maxMonthlyPercentAllowed: number,
    SPOCs: [],
    availableForDeployment: number,
    communicationCycles: [],
    defaultInactiveNextStatus: string,
    defaultSignupStatus: string,
    maxMonthlyRequestsLimitPerUser: number,
    establishedAt: string,
    departments: [],
    deploymentDate?: string,
    freePeriodExpiryDate?: string,
}
export interface userInfo {
    name: string,
    companyName: string,
    phone: string,
    email: string,

    consent: [],
    nationalId: any,
    hrLetter: [],
    accountCreatedAt: string,
    bankAccountHolderName: string,
    bankAccountNumber: string,
    bankName: string,

    userStatus: string,
    userStatusType: string,

    maxAdvancePercentAllowedPerCompany: number,
    maxBalance: number,
    maxShoppingBalnce: number,

    wallet: number,
    staff_id: string,
    companyMaxInstallmentCount: number,
    nationalIDNumber: string,
    netSalary: any,
    maxMonthlyRequestsLimit: any,
}
export interface resolveIssues {
    actionsReducer: any;
}
export interface transactionInterface {
    transaction: {
        company: string,
        totalAmount: string,
        name: string,
        transactionID: number,
        referenceNumber: number,
        createdAt: string,
        serviceOne: string,
        serviceTwo: string,
        serviceThree: string,
        serviceFour: string,
        companyRef: string,
        logoURL: string,
        actionBy: {
            firstName: string,
            lastName: string,
            middleName: string,
        },
        transactionsBreakdown: any[],
        userID: {
            staffID: string,
            nationalID: string,
            company: {
                logoURL: string
            }
        },
    }
}

export interface ITableCol {
    [x: string]: any;
    title: string;
    dataIndex: string;
    render?: (value: string) => JSX.Element;

}
export interface IUserAccounts {
    userID: string,
    phoneNumber: string,
    staffID: string,
    userName: string,
    companyName: string,
    userStatus: string,
}
export enum CallCenterModules {
    willPay = 17
}

export interface EditCompanyFeesProps {
    isDeployedCompany?: boolean
}

export interface ITableColumn {
    title: string;
    dataIndex: string;
    key: string;
}
export interface ITable {
    data: any[];
    columns: ITableColumn[];
    loading: boolean;
    currentPage?: number;
    total?: number;
    perPage?: number;
}

export enum MeezaCardStatus {
    notReceived,
    requested,
    received
}

export enum paymentTypes {
    fullSettlement = 0,
    partialSettlement = 1,
}
export interface ICollection {
    id?: number;
    amount?: number;
    collectionDate?: string;
    paymentCycle?: number;
    companyName?: string;
    serialNumber?: string;
    invoiceID?: number;
    fullyPaid?: boolean;

/**
 * Semantic Versioning (SemVer) Types:
 *
 * MAJOR (x.0.0): Breaking changes - Changes that break backward compatibility
 * MINOR (x.y.0): New features - Backward compatible additions
 * PATCH (x.y.z): Bug fixes - Backward compatible bug fixes
 */
}
export interface IReleaseNote {
    version: string; // Format: v1.19.35 (MAJOR.MINOR.PATCH)
    date: string;
    notes: string[];
    type: 'feature' | 'fix' | 'security' | 'improvement';
    versionType: 'MAJOR' | 'MINOR' | 'PATCH';
}

export enum UsageLevelTags {
    High = 22,
    Medium = 23,
    Low = 24,
}

export enum UserTagCategories {
    Main = 1,
    Behavioral = 2,
    UsageLevel = 3,
}

export interface UserTag {
    categoryID: UserTagCategories,
    categoryName: string,
    tagID: number | UsageLevelTags,
    tagName: string,
    parentTagID: UserTagCategories | null,
}

export enum UserDocType {
    Consent = 1,
    NationalId = 2,
    HrLetter = 3,
    TrustReceipt = 7,
}

export enum CompaniesIds {
    egyptPostOffice = 1629,
    petrojet = 1582,
}

export enum DebtReschedulingEligibilityStatus {
    eligible = 'Eligible',
    notEligible = 'Not Eligible',
}

export enum DebtReschedulingConditionStatus {
    met = 'Met',
    notMet = 'Not Met',
}
